<template>
  <v-container
    fluid
    class="grey lighten-5 fill-height"
  >
    <v-layout column>
      <v-flex>
        <CardsLine
          header="Trash"
          :data="trashed"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import CardsLine from '../components/CardsLine';

export default {
  name: 'Trash',
  components: {
    CardsLine
  },
  computed: {
    trashed() {
      return this.$store.state.trash;
    },
  },    
};
</script>


<style scoped>
</style>
